export const SET_SNACKBAR   =   'SET_SNACKBAR '
export const SET_SNACKBAR_MESSAGE   =   'SET_SNACKBAR_MESSAGE '
export const SET_SNACKBAR_VARIANT = 'SET_SNACKBAR_VARIANT'

